// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"b200d53e","98":"ba9f82e4","614":"fbe62bd0","637":"660b9873","640":"1cd5f9c3","717":"5e43779c","762":"54a89a19","884":"8c2e94e2"}[chunkId] + ".chunk.js";
};